/* @flow */
export default function isSeller(sellerUserId, userId) {
  return sellerUserId === userId;
}
